"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWrapper = exports.InitialsButtonContainer = exports.TitleWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.TitleWrapper = styled_components_1.default.span `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  padding-top: 4px;
  color: ${colors_1.WHITE};
  letter-spacing: 0.5px;
`;
const baseCss = (0, styled_components_1.css) `
  align-items: center;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  outline: none;
`;
exports.InitialsButtonContainer = styled_components_1.default.button `
  ${baseCss}
  padding: 0;
  background-color: ${colors_1.ORANGE};
  width: 32px;
`;
exports.ImageWrapper = styled_components_1.default.div `
  ${baseCss}
  overflow: hidden;
  width: 32px;
  img {
    max-width: 100%;
  }
`;
//# sourceMappingURL=InitialsButton.styles.js.map